export default "__VITE_ASSET__DHZP2w2b__"